import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6a6c33fc = () => interopDefault(import('../pages/zapis/success.vue' /* webpackChunkName: "pages/zapis/success" */))
const _adea0972 = () => interopDefault(import('../pages/zapis/error.vue' /* webpackChunkName: "pages/zapis/error" */))
const _a571f0e8 = () => interopDefault(import('../pages/zapis/_slug/index.vue' /* webpackChunkName: "pages/zapis/_slug/index" */))
const _6544dd11 = () => interopDefault(import('../pages/zapis/index.vue' /* webpackChunkName: "pages/zapis/index" */))
const _369ff7cc = () => interopDefault(import('../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _6c47d279 = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _4371967e = () => interopDefault(import('../pages/vakansii/index.vue' /* webpackChunkName: "pages/vakansii/index" */))
const _4a00b9dc = () => interopDefault(import('../pages/uslugi/_slug/index.vue' /* webpackChunkName: "" */))
const _9af2e93e = () => interopDefault(import('../pages/uslugi/index.vue' /* webpackChunkName: "pages/uslugi/index" */))
const _655c927c = () => interopDefault(import('../pages/stat/_category/_article/index.vue' /* webpackChunkName: "pages/stat/_category/_article/index" */))
const _b05c708c = () => interopDefault(import('../pages/stat/_category/index.vue' /* webpackChunkName: "pages/stat/_category/index" */))
const _73b17f6c = () => interopDefault(import('../pages/stat/index.vue' /* webpackChunkName: "pages/stat/index" */))
const _87969eb0 = () => interopDefault(import('../pages/specialists/components/SpecialistCard.vue' /* webpackChunkName: "pages/specialists/components/SpecialistCard" */))
const _2428516e = () => interopDefault(import('../pages/specialists/components/Header/SpecialistHeader.vue' /* webpackChunkName: "pages/specialists/components/Header/SpecialistHeader" */))
const _d8710f40 = () => interopDefault(import('../pages/specialists/index.vue' /* webpackChunkName: "" */))
const _34564e64 = () => interopDefault(import('../pages/search/components/Articles.vue' /* webpackChunkName: "pages/search/components/Articles" */))
const _5cb20b00 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _153e1d06 = () => interopDefault(import('../pages/reviews/AddReviewModal.vue' /* webpackChunkName: "pages/reviews/AddReviewModal" */))
const _453be54e = () => interopDefault(import('../pages/reviews/index.vue' /* webpackChunkName: "pages/reviews/index" */))
const _415f1a91 = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _78150d7f = () => interopDefault(import('../pages/questions-specialist/_question/index.vue' /* webpackChunkName: "pages/questions-specialist/_question/index" */))
const _1ad06eee = () => interopDefault(import('../pages/questions-specialist/index.vue' /* webpackChunkName: "pages/questions-specialist/index" */))
const _64eb5dab = () => interopDefault(import('../pages/profile/zapis/index.vue' /* webpackChunkName: "pages/profile/zapis/index" */))
const _25b337a8 = () => interopDefault(import('../pages/profile/my-acuvue/index.vue' /* webpackChunkName: "pages/profile/my-acuvue/index" */))
const _3af18070 = () => interopDefault(import('../pages/profile/edit/index.vue' /* webpackChunkName: "pages/profile/edit/index" */))
const _5d7ebeb8 = () => interopDefault(import('../pages/profile/discount-card/get-card/index.vue' /* webpackChunkName: "pages/profile/discount-card/get-card/index" */))
const _5512670d = () => interopDefault(import('../pages/profile/discount-card/_guid/index.vue' /* webpackChunkName: "pages/profile/discount-card/_guid/index" */))
const _8bf6b718 = () => interopDefault(import('../pages/profile/discount-card/index.vue' /* webpackChunkName: "pages/profile/discount-card/index" */))
const _3d9979fa = () => interopDefault(import('../pages/profile/certificates/index.vue' /* webpackChunkName: "pages/profile/certificates/index" */))
const _ca931436 = () => interopDefault(import('../pages/profile/bonuses/index.vue' /* webpackChunkName: "pages/profile/bonuses/index" */))
const _5274ed32 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _ab94a1f2 = () => interopDefault(import('../pages/product/test.vue' /* webpackChunkName: "pages/product/test" */))
const _2970d5b2 = () => interopDefault(import('../pages/product/glassesCardPage_v2.vue' /* webpackChunkName: "pages/product/glassesCardPage_v2" */))
const _98c16836 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _0f1fa30f = () => interopDefault(import('../pages/checkout/success.vue' /* webpackChunkName: "" */))
const _4a3c6392 = () => interopDefault(import('../pages/order/payment/cancel/_hash.vue' /* webpackChunkName: "pages/order/payment/cancel/_hash" */))
const _eda86b44 = () => interopDefault(import('../pages/order/payment/_hash.vue' /* webpackChunkName: "pages/order/payment/_hash" */))
const _c255154e = () => interopDefault(import('../pages/checkout/process/_hash.vue' /* webpackChunkName: "" */))
const _dd1e0404 = () => interopDefault(import('../pages/ochki/_category/index.vue' /* webpackChunkName: "pages/ochki/_category/index" */))
const _16eefab0 = () => interopDefault(import('../pages/ochki/index.vue' /* webpackChunkName: "pages/ochki/index" */))
const _a1fcd56c = () => interopDefault(import('../pages/misight1day/index.vue' /* webpackChunkName: "pages/misight1day/index" */))
const _4f209103 = () => interopDefault(import('../pages/miopiya/indexOriginal.vue' /* webpackChunkName: "pages/miopiya/indexOriginal" */))
const _43c24538 = () => interopDefault(import('../pages/miopiya/components/QRList.vue' /* webpackChunkName: "pages/miopiya/components/QRList" */))
const _1fb6b718 = () => interopDefault(import('../pages/miopiya/components/MiopiyaReasons.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaReasons" */))
const _1fb6b00a = () => interopDefault(import('../pages/miopiya/components/MiopiyaPrevention.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaPrevention" */))
const _4c78c4dc = () => interopDefault(import('../pages/miopiya/index.vue' /* webpackChunkName: "pages/miopiya/index" */))
const _83741358 = () => interopDefault(import('../pages/lenses/competitors/_slug.vue' /* webpackChunkName: "pages/lenses/competitors/_slug" */))
const _078bdf5c = () => interopDefault(import('../pages/lenses/_category/index.vue' /* webpackChunkName: "pages/lenses/_category/index" */))
const _fab1b3f8 = () => interopDefault(import('../pages/lenses/index.vue' /* webpackChunkName: "pages/lenses/index" */))
const _98fd576a = () => interopDefault(import('../pages/information_message/informationMessage.vue' /* webpackChunkName: "pages/information_message/informationMessage" */))
const _dbb58c02 = () => interopDefault(import('../pages/get-card/index.vue' /* webpackChunkName: "pages/get-card/index" */))
const _2be19310 = () => interopDefault(import('../pages/company/questions/page.vue' /* webpackChunkName: "pages/company/questions/page" */))
const _84791164 = () => interopDefault(import('../pages/company/questions/letterModal.vue' /* webpackChunkName: "pages/company/questions/letterModal" */))
const _adc85cb4 = () => interopDefault(import('../pages/cms-page-preview/index.vue' /* webpackChunkName: "pages/cms-page-preview/index" */))
const _fa4f4ee8 = () => interopDefault(import('../pages/checkout/process/new.vue' /* webpackChunkName: "pages/checkout/process/new" */))
const _607929be = () => interopDefault(import('../pages/checkout/process/index.vue' /* webpackChunkName: "pages/checkout/process/index" */))
const _a3df0d44 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _6d6aa358 = () => interopDefault(import('../pages/charity/_category/_article/index.vue' /* webpackChunkName: "pages/charity/_category/_article/index" */))
const _125e3a64 = () => interopDefault(import('../pages/charity/_category/index.vue' /* webpackChunkName: "pages/charity/_category/index" */))
const _7a435e96 = () => interopDefault(import('../pages/charity/index.vue' /* webpackChunkName: "pages/charity/index" */))
const _45fb3bb1 = () => interopDefault(import('../pages/catalog/components/SelectedFilter.vue' /* webpackChunkName: "pages/catalog/components/SelectedFilter" */))
const _27697cd6 = () => interopDefault(import('../pages/catalog/components/FilterMobileComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterMobileComponent" */))
const _dfd596d2 = () => interopDefault(import('../pages/catalog/components/FilterComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterComponent" */))
const _651622ce = () => interopDefault(import('../pages/catalog/components/ContactLinzCategory.vue' /* webpackChunkName: "pages/catalog/components/ContactLinzCategory" */))
const _1f1681d8 = () => interopDefault(import('../pages/catalog/components/ArticleCard.vue' /* webpackChunkName: "pages/catalog/components/ArticleCard" */))
const _39b91b64 = () => interopDefault(import('../pages/catalog/_.vue' /* webpackChunkName: "pages/catalog/_" */))
const _27d113d7 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _e6900546 = () => interopDefault(import('../pages/cart_old.vue' /* webpackChunkName: "pages/cart_old" */))
const _5bbbe160 = () => interopDefault(import('../pages/cart/checkout.vue' /* webpackChunkName: "pages/cart/checkout" */))
const _a235ed1c = () => interopDefault(import('../pages/cart-old/done.vue' /* webpackChunkName: "pages/cart-old/done" */))
const _cfdd81c4 = () => interopDefault(import('../pages/cart-old/basketPageThirdStep.vue' /* webpackChunkName: "pages/cart-old/basketPageThirdStep" */))
const _4d1755b6 = () => interopDefault(import('../pages/cart-old/basketPageSecondStep.vue' /* webpackChunkName: "pages/cart-old/basketPageSecondStep" */))
const _c3b62ddc = () => interopDefault(import('../pages/cart-old/index.vue' /* webpackChunkName: "pages/cart-old/index" */))
const _24e76538 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _b8dfa066 = () => interopDefault(import('../pages/bystraya-zapis/index.vue' /* webpackChunkName: "pages/bystraya-zapis/index" */))
const _30c7e5f7 = () => interopDefault(import('../pages/authorization/index.vue' /* webpackChunkName: "pages/authorization/index" */))
const _0ca4386a = () => interopDefault(import('../pages/appointment/appointment.vue' /* webpackChunkName: "pages/appointment/appointment" */))
const _e4b7a5c8 = () => interopDefault(import('../pages/aktsii/_slug/index.vue' /* webpackChunkName: "pages/aktsii/_slug/index" */))
const _f4dd22be = () => interopDefault(import('../pages/aktsii/index.vue' /* webpackChunkName: "pages/aktsii/index" */))
const _b9104af8 = () => interopDefault(import('../pages/acuvue/phoneRegistrationForm.vue' /* webpackChunkName: "pages/acuvue/phoneRegistrationForm" */))
const _6cddef2b = () => interopDefault(import('../pages/acuvue/index.vue' /* webpackChunkName: "pages/acuvue/index" */))
const _658f3fda = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/zapis/success",
    component: _6a6c33fc,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-success"
  }, {
    path: "/zapis/error",
    component: _adea0972,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-error"
  }, {
    path: "/zapis/:slug",
    component: _a571f0e8,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-slug"
  }, {
    path: "/zapis",
    component: _6544dd11,
    pathToRegexpOptions: {"strict":true},
    name: "zapis"
  }, {
    path: "/wishlist",
    component: _369ff7cc,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist"
  }, {
    path: "/video",
    component: _6c47d279,
    pathToRegexpOptions: {"strict":true},
    name: "video"
  }, {
    path: "/vakansii",
    component: _4371967e,
    pathToRegexpOptions: {"strict":true},
    name: "vakansii"
  }, {
    path: "/uslugi/:slug/:service",
    components: {
      default: _4a00b9dc
    }
  }, {
    path: "/uslugi/:slug",
    component: _4a00b9dc,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi-slug"
  }, {
    path: "/uslugi",
    component: _9af2e93e,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi"
  }, {
    path: "/stat/:category/:article",
    component: _655c927c,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category-article"
  }, {
    path: "/stat/:category",
    component: _b05c708c,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category"
  }, {
    path: "/stat",
    component: _73b17f6c,
    pathToRegexpOptions: {"strict":true},
    name: "stat"
  }, {
    path: "/specialists/components/SpecialistCard",
    component: _87969eb0,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-SpecialistCard"
  }, {
    path: "/specialists/components/Header/SpecialistHeader",
    component: _2428516e,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-Header-SpecialistHeader"
  }, {
    path: "/specialists/:id",
    components: {
      default: _d8710f40
    }
  }, {
    path: "/specialists",
    component: _d8710f40,
    pathToRegexpOptions: {"strict":true},
    name: "specialists"
  }, {
    path: "/search/components/Articles",
    component: _34564e64,
    pathToRegexpOptions: {"strict":true},
    name: "search-components-Articles"
  }, {
    path: "/search",
    component: _5cb20b00,
    pathToRegexpOptions: {"strict":true},
    name: "search"
  }, {
    path: "/reviews/AddReviewModal",
    component: _153e1d06,
    pathToRegexpOptions: {"strict":true},
    name: "reviews-AddReviewModal"
  }, {
    path: "/reviews",
    component: _453be54e,
    pathToRegexpOptions: {"strict":true},
    name: "reviews"
  }, {
    path: "/registration",
    component: _415f1a91,
    pathToRegexpOptions: {"strict":true},
    name: "registration"
  }, {
    path: "/questions-specialist/:question",
    component: _78150d7f,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist-question"
  }, {
    path: "/questions-specialist",
    component: _1ad06eee,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist"
  }, {
    path: "/profile/zapis",
    component: _64eb5dab,
    pathToRegexpOptions: {"strict":true},
    name: "profile-zapis"
  }, {
    path: "/profile/my-acuvue",
    component: _25b337a8,
    pathToRegexpOptions: {"strict":true},
    name: "profile-my-acuvue"
  }, {
    path: "/profile/edit",
    component: _3af18070,
    pathToRegexpOptions: {"strict":true},
    name: "profile-edit"
  }, {
    path: "/profile/discount-card/get-card",
    component: _5d7ebeb8,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card-get-card"
  }, {
    path: "/profile/discount-card/:guid",
    component: _5512670d,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card-guid"
  }, {
    path: "/profile/discount-card",
    component: _8bf6b718,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card"
  }, {
    path: "/profile/certificates",
    component: _3d9979fa,
    pathToRegexpOptions: {"strict":true},
    name: "profile-certificates"
  }, {
    path: "/profile/bonuses",
    component: _ca931436,
    pathToRegexpOptions: {"strict":true},
    name: "profile-bonuses"
  }, {
    path: "/profile",
    component: _5274ed32,
    pathToRegexpOptions: {"strict":true},
    name: "profile"
  }, {
    path: "/product/test",
    component: _ab94a1f2,
    pathToRegexpOptions: {"strict":true},
    name: "product-test"
  }, {
    path: "/product/glassesCardPage_v2",
    component: _2970d5b2,
    pathToRegexpOptions: {"strict":true},
    name: "product-glassesCardPage_v2"
  }, {
    path: "/product/:slug?",
    component: _98c16836,
    pathToRegexpOptions: {"strict":true},
    name: "product-slug"
  }, {
    path: "/order/success/:hash",
    components: {
      default: _0f1fa30f
    }
  }, {
    path: "/order/payment/cancel/:hash?",
    component: _4a3c6392,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-cancel-hash"
  }, {
    path: "/order/payment/:hash?",
    component: _eda86b44,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-hash"
  }, {
    path: "/order/:hash",
    components: {
      default: _c255154e
    }
  }, {
    path: "/ochki/:category",
    component: _dd1e0404,
    pathToRegexpOptions: {"strict":true},
    name: "ochki-category"
  }, {
    path: "/ochki",
    component: _16eefab0,
    pathToRegexpOptions: {"strict":true},
    name: "ochki"
  }, {
    path: "/misight1day",
    component: _a1fcd56c,
    pathToRegexpOptions: {"strict":true},
    name: "misight1day"
  }, {
    path: "/miopiya/indexOriginal",
    component: _4f209103,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-indexOriginal"
  }, {
    path: "/miopiya/components/QRList",
    component: _43c24538,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-QRList"
  }, {
    path: "/miopiya/components/MiopiyaReasons",
    component: _1fb6b718,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaReasons"
  }, {
    path: "/miopiya/components/MiopiyaPrevention",
    component: _1fb6b00a,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaPrevention"
  }, {
    path: "/miopiya",
    component: _4c78c4dc,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya"
  }, {
    path: "/lenses/competitors/:slug?",
    component: _83741358,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-competitors-slug"
  }, {
    path: "/lenses/:category",
    component: _078bdf5c,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-category"
  }, {
    path: "/lenses",
    component: _fab1b3f8,
    pathToRegexpOptions: {"strict":true},
    name: "lenses"
  }, {
    path: "/information_message/informationMessage",
    component: _98fd576a,
    pathToRegexpOptions: {"strict":true},
    name: "information_message-informationMessage"
  }, {
    path: "/get-card",
    component: _dbb58c02,
    pathToRegexpOptions: {"strict":true},
    name: "get-card"
  }, {
    path: "/company/questions/page",
    component: _2be19310,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-page"
  }, {
    path: "/company/questions/letterModal",
    component: _84791164,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-letterModal"
  }, {
    path: "/cms-page-preview",
    component: _adc85cb4,
    pathToRegexpOptions: {"strict":true},
    name: "cms-page-preview"
  }, {
    path: "/checkout/success",
    component: _0f1fa30f,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-success"
  }, {
    path: "/checkout/process/new",
    component: _fa4f4ee8,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-new"
  }, {
    path: "/checkout/process/:hash",
    component: _c255154e,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-hash"
  }, {
    path: "/checkout/process",
    component: _607929be,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process"
  }, {
    path: "/checkout",
    component: _a3df0d44,
    pathToRegexpOptions: {"strict":true},
    name: "checkout"
  }, {
    path: "/charity/:category/:article",
    component: _6d6aa358,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category-article"
  }, {
    path: "/charity/:category",
    component: _125e3a64,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category"
  }, {
    path: "/charity",
    component: _7a435e96,
    pathToRegexpOptions: {"strict":true},
    name: "charity"
  }, {
    path: "/catalog/components/SelectedFilter",
    component: _45fb3bb1,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-SelectedFilter"
  }, {
    path: "/catalog/components/FilterMobileComponent",
    component: _27697cd6,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterMobileComponent"
  }, {
    path: "/catalog/components/FilterComponent",
    component: _dfd596d2,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterComponent"
  }, {
    path: "/catalog/components/ContactLinzCategory",
    component: _651622ce,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ContactLinzCategory"
  }, {
    path: "/catalog/components/ArticleCard",
    component: _1f1681d8,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ArticleCard"
  }, {
    path: "/catalog/*",
    component: _39b91b64,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-all"
  }, {
    path: "/catalog",
    component: _27d113d7,
    pathToRegexpOptions: {"strict":true},
    name: "catalog"
  }, {
    path: "/cart_old",
    component: _e6900546,
    pathToRegexpOptions: {"strict":true},
    name: "cart_old"
  }, {
    path: "/cart/checkout",
    component: _5bbbe160,
    pathToRegexpOptions: {"strict":true},
    name: "cart-checkout"
  }, {
    path: "/cart-old/done",
    component: _a235ed1c,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-done"
  }, {
    path: "/cart-old/basketPageThirdStep",
    component: _cfdd81c4,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageThirdStep"
  }, {
    path: "/cart-old/basketPageSecondStep",
    component: _4d1755b6,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageSecondStep"
  }, {
    path: "/cart-old",
    component: _c3b62ddc,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old"
  }, {
    path: "/cart",
    component: _24e76538,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/bystraya-zapis",
    component: _b8dfa066,
    pathToRegexpOptions: {"strict":true},
    name: "bystraya-zapis"
  }, {
    path: "/authorization",
    component: _30c7e5f7,
    pathToRegexpOptions: {"strict":true},
    name: "authorization"
  }, {
    path: "/appointment/appointment",
    component: _0ca4386a,
    pathToRegexpOptions: {"strict":true},
    name: "appointment-appointment"
  }, {
    path: "/aktsii/:slug",
    component: _e4b7a5c8,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii-slug"
  }, {
    path: "/aktsii",
    component: _f4dd22be,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii"
  }, {
    path: "/acuvue/phoneRegistrationForm",
    component: _b9104af8,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue-phoneRegistrationForm"
  }, {
    path: "/acuvue",
    component: _6cddef2b,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue"
  }, {
    path: "/*",
    component: _658f3fda,
    pathToRegexpOptions: {"strict":true},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
